import { Fragment } from 'react';

import type { PopulatedMediaAuthor } from '@/features/media-authors/types';
import { MediaAuthorLink } from './media-author-link';

type MediaAuthorNamesProps = {
  readonly authors?: ReadonlyArray<PopulatedMediaAuthor> | null;
  readonly className?: string;
  readonly fallback?: string;
};

/**
 * Renders article author names: active media authors as links, others as plain text.
 */
export function MediaAuthorNames({
  authors,
  className,
  fallback = 'Molwe',
}: MediaAuthorNamesProps) {
  if (!authors?.length) {
    return <span className={className}>{fallback}</span>;
  }

  return (
    <span className={className}>
      {authors.map((author, index) => (
        <Fragment key={author.id ?? `${author.name}-${index}`}>
          {index > 0 ? ', ' : null}
          <MediaAuthorLink
            slug={author.slug}
            url={author.url}
            isActive={author.isActive}
            isPublished={author.isPublished}
          >
            {author.name}
          </MediaAuthorLink>
        </Fragment>
      ))}
    </span>
  );
}
